import { defaultReceivingFixture, ReceivingFlowFixture, ReceivingLocationSummary } from './fixtures'

// One effective fixture context for validation and Preview, including retained pre-location state.
export const locationContext = (fixture: ReceivingFlowFixture) => ({
  warehouseId: fixture.warehouseId ?? defaultReceivingFixture.warehouseId,
  locations: fixture.locations ?? defaultReceivingFixture.locations,
})
export const locationOutcomeLabel = (fixture: ReceivingFlowFixture, location: ReceivingLocationSummary) => {
  const kind =
    location.warehouseId !== locationContext(fixture).warehouseId
      ? 'Wrong warehouse'
      : !location.active
        ? 'Inactive'
        : 'Valid'
  return `${kind} · ${location.barcode}`
}
